import { render } from "./multaobligacion.vue?vue&type=template&id=835722d2&scoped=true"
import script from "./multaobligacion.vue?vue&type=script&lang=js"
export * from "./multaobligacion.vue?vue&type=script&lang=js"

import "./multaobligacion.vue?vue&type=style&index=0&id=835722d2&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-835722d2"]])

export default __exports__